<template>
  <div class="clearfix overflow-hidden collapse-box">
    <div
      class="vc-collapse overflow-hidden float-left clearfix"
      v-for="(item, index) in kilns"
      :key="item.id"
      @click="beforeOpen(item, index)"
    >
      <div
        class="header h-full text-left float-left cursor-pointer relative"
        :style="`background-color:${colorList[index]}`"
      >
        <span class="time text-center inline-block absolute">{{
          item.dynasty ? item.dynasty.slice(0, 1) : ''
        }}</span>
        <span class="inline-block">{{ item.title }}</span>
        <span class="icon inline-block absolute"></span>
      </div>

      <div
        :id="`content${index}`"
        :class="
          item.id === selectedId
            ? 'my-content h-full float-left relative'
            : 'my-content h-full float-left no-selected relative'
        "
        :style="
          `background-image:url('${item.image_url}');width:${contentWidth};`
        "
      >
        <div class="absolute pin-b pin-x description text-left cursor-default">
          {{ item.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'collapse',
  props: {},
  data() {
    return {
      selectedId: '',
      colorList: [
        '#585778',
        '#626185',
        '#717091',
        '#7f7e9c',
        '#626185',
        '#717091',
        '#7f7e9c',
        '#8c8ba6',
        '#7f7e9c',
        '#9098ac',
        '#a0a9bf',
        '#a9b1c5',
        '#b1b9cb',
        '#b9c0d0',
        '#585778',
        '#626185',
        '#717091',
        '#7f7e9c',
        '#626185',
        '#717091',
        '#7f7e9c',
        '#8c8ba6',
        '#7f7e9c',
        '#9098ac',
        '#a0a9bf',
        '#a9b1c5',
        '#b1b9cb',
        '#b9c0d0'
      ]
    }
  },
  computed: {
    kilns() {
      let data = this.$store.getters['HomeStore/kilns']
      if (data === false) {
        return false
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.selectedId = data[0].id
      return data
    },
    contentWidth() {
      let str = '0'
      if (this.kilns) {
        str = 1199 - 45 * this.kilns.length
      }
      return `${str}px`
    }
  },
  mounted: function() {},
  methods: {
    beforeOpen(item) {
      this.selectedId = item.id
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';

.my-content {
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease; /* Firefox 4 */
  -webkit-transition: all 0.5s ease; /* Safari 和 Chrome */
  -o-transition: all 0.5s ease; /* Opera */
}
.no-selected.my-content {
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease; /* Firefox 4 */
  -webkit-transition: all 0.5s ease; /* Safari 和 Chrome */
  -o-transition: all 0.5s ease; /* Opera */
  width: 0 !important;
  font-size: 0;
  opacity: 0;
}

.collapse-box {
  height: 500px;
  border-right: 1px solid $c-transparent;
}
.vc-collapse {
  height: 500px;
  box-sizing: border-box;
  .header {
    width: 45px;
    line-height: 45px;
    font-size: 18px;
    color: $c-white;
    word-wrap: break-word; /*英文的时候需要加上这句，自动换行*/
    writing-mode: vertical-lr; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
    writing-mode: tb-lr; /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/

    padding: 65px 0 40px 0;
    overflow: hidden;
    -o-text-overflow: ellipsis; /* Opera 9-10 */
    text-overflow: ellipsis;
    white-space: nowrap;

    .time,
    .icon {
      border: 1px solid $c-white;
      border-radius: 50%;
    }
    .time {
      width: 33px;
      height: 33px;
      line-height: 32px;
      top: 22px;
      left: 5px;
    }
    .icon {
      width: 25px;
      height: 25px;
      bottom: 12px;
      left: 9px;
      background: url('../../../static/images/public/arrow-right-border.png')
        60% center no-repeat;
    }
  }
  .my-content {
    background-color: $c-transparent;
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 100%;
  }
  .description {
    height: 35%;
    padding: 20px;
    line-height: 1.9;
    color: $c-white;
    background-color: $c-transparent-6;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }
}
</style>
